import { GET_ANNOUNCEMENTS } from "../graphql/queries/announcements";
import { useQuery } from "@apollo/client";

export const useAnnouncements = () => {
  const { loading, error, data } = useQuery(GET_ANNOUNCEMENTS);
  return {
    loading,
    data,
    error,
  };
};
